const ptJSON = {
  Blueprints: 'Plantas',
  'Extended Sidebar': 'Barra lateral estendida',
  'Accent Sidebar': 'Barra Lateral de Acento',
  'Accent Header': 'Cabeçalho de destaque',
  'Boxed Sidebar': 'Barra lateral em caixa',
  'Collapsed Sidebar': 'Barra lateral recolhida',
  'Bottom Navigation': 'Navegação inferior',
  'Top Navigation': 'Navegação superior',
  'Lead Developer': 'Desenvolvedor-chefe',
  'Mega menu': 'Mega cardápio',
  Doctors: 'Doutores',
  Reference: 'Referência',
  Reports: 'Relatórios',
  'Custom dashboard built using the included components':
    'Painel personalizado construído usando os componentes incluídos',
  Hospital: 'Hospital',
  'field is required': 'campo obrigatório',
  Export: 'Exportação',
  'Bulk actions': 'Ações em massa',
  'Last year': 'Último ano',
  Expenses: 'Despesas',
  Products: 'Produtos',
  Statistics: 'Estatísticas',
  General: 'Geral',
  Automation: 'Automação',
  'Data Display': 'Exibir Dados',
  Calendar: 'Calendário',
  Mailbox: 'Caixa de Email',
  Dashboards: 'Dashboards',
  Analytics: 'Analytics',
  Banking: 'Bancário',
  Commerce: 'Comércio',
  Crypto: 'Crypto',
  Finance: 'Financeiro',
  Details: 'Detalhes',
  Fitness: 'Fitness',
  Healthcare: 'Cuidados de saúde',
  'Doctors Page': 'Pagína de Médicos',
  'Hospital Overview': 'Visão do Hospital',
  Helpdesk: 'Helpdesk',
  Learning: 'Aprendizado',
  Monitoring: 'Monitoramento',
  Tasks: 'Tarefas',
  'lot shipping': 'Envio de lote',
  Applications: 'Aplicações',
  'File Manager': 'Gerenciador de Arquivos',
  'Jobs Platform': 'Plataforma de trabalho',
  Messenger: 'Mensagem',
  Subsidy: 'Subsídio',
  'Monthly payment': 'Mensalidade',
  'Projects Board': 'Conselho de Projetos',
  Management: 'Gerenciamento',
  Users: 'Usuários',
  Parameters: 'Parâmetros',
  'Type of registration parameters': 'Tipo de parâmetros de cadastro',
  'Users - Management': 'Usuários - Gerenciamento',
  'Create Parameters': 'Criar Parâmetro',
  'Create user': 'Criar Usuário',
  'All users': 'Todos Usuários',
  'Search by name, email, cpf, application or laboratory code...':
    'Pesquise por nome, e-mail, cpf, aplicação ou código do laboratório...',
  "We couldn't find any users matching your search criteria":
    'Não encontramos nenhum usuário que corresponda aos seus critérios de pesquisa',
  Username: 'nome de usuário',
  fullName: 'Nome completo',
  'Zip Code': 'CEP',
  Street: 'Endereço',
  Number: 'Número',
  Neighborhood: 'Bairro',
  City: 'Cidade',
  State: 'Estado',
  Country: 'País',
  Address: 'Endereço',
  'Cell Phone': 'Celular',
  phone: 'telefone',
  Phone: 'Telefone',
  'Phone must be at least 10 characters':
    'O telefone deve ter pelo menos 10 caracteres',
  'Phone must be at most 15 characters':
    'O telefone deve ter no máximo 15 caracteres',
  'Phone Number': 'Número de Telefone',
  'The CPF field is required': 'O campo CPF é obrigatório',
  'Add new user': 'Adicionar novo usuário',
  'Fill in the fields below to create and add a new user to the site':
    'Preencha os campos abaixo para criar e adicionar um novo usuário',
  Name: 'Nome',
  Email: 'Email',
  Role: 'perfil',
  Actions: 'Ação',
  Administrators: 'Administradores',
  Subscribers: 'Assinantes',
  Customers: 'Cliente',
  'Create new parameter': 'Criar novo pârametro',
  'Fill in the fields below to create and add a new parameter':
    'Preencha os campos abaixo para criar um novo parâmetro',
  Cancel: 'Cancelar',
  'All aspects related to the app users can be managed from this page':
    'Todos os aspectos relacionados aos usuários do aplicativo podem ser gerenciados nesta página',
  'List All': 'Listar todos',
  List: 'Lista',
  'User Profile': 'Perfil de Usuário',
  'Users Management': 'Gerenciamento de Usuários',
  Projects: 'Projetos',
  Shop: 'Comprar',
  'Products List': 'Lista de Produtos',
  'View Product': 'Visualizar Produto',
  'Create Product': 'Criar Produto',
  Invoices: 'Notas Fiscais',
  'View Single': 'Ver individualmente',
  'Auth Pages': 'Páginas de Login',
  Login: 'Login',
  Basic: 'Básico',
  Cover: 'Cobrir',
  Register: 'Registro',
  Wizard: 'Mágico',
  'Recover Password': 'Recuperar Senha',
  Status: 'Status',
  Foundation: 'Fundação',
  'Extra Pages': 'Páginas Extras',
  'Error 404': 'Error 404',
  'Error 500': 'Error 500',
  'Coming Soon': 'Em breve',
  Maintenance: 'Manutenção',
  Overview: 'Visão Geral',
  'Layout Starters': 'Layout Inicial',
  'Starter Kit 1': 'Kit Inicial 1',
  'Starter Kit 2': 'Kit Inicial 1',
  'An unexpected error occurred': 'Ocorreu um erro inesperado',
  Documentation: 'Documentação',
  Welcome: 'Bem-Vindo',
  Help: 'Help',
  'Features tour': 'Tour de Recursos',
  'Getting started guide': 'Guia de Onboarding',
  'Contact support': 'Entre em Contato com o Suporte',
  Version: 'Versão',
  Search: 'Buscar',
  Notifications: 'Notificações',
  Settings: 'Definições',
  'Language Switcher': 'Alternar Idioma',
  'Sign out': 'Logout',
  'Change Theme': 'Mudar tema',
  'View all notifications': 'Ver todas as notificações',
  'Tokyo NextJS Typescript Admin Dashboard':
    'Painel de administração Tokyo NextJS Typescript',
  'High performance React template built with lots of powerful Material-UI components across multiple product niches for fast & perfect apps development processes':
    'Modelo React de alto desempenho construído com muitos componentes poderosos de Material-UI em vários nichos de produtos para processos de desenvolvimento de aplicativos rápidos e perfeitos',
  'Browse Live Preview': 'Visualização ao vivo via Browser',
  'Live Preview': 'Visualização ao vivo',
  'Key Features': 'Principais características',
  dashboards: 'dashboards',
  applications: 'aplicações',
  application: 'aplicação',
  Application: 'Aplicação',
  'management sections': 'gerenciamento de sessões',
  'dark/light themes': 'temas dark/light',
  components: 'componentes',
  'Some of the features that make Tokyo one of the best admin templates available today':
    'Alguns dos recursos que tornam Tóquio um dos melhores modelos de administração disponíveis atualmente',
  'Design Source Files': 'Arquivos de origem do design',
  'Start working on your project directly from one of the included starter kits or use the Figma/Sketch files to create a prototype first':
    'Comece a trabalhar em seu projeto diretamente de um dos kits iniciais incluídos ou use os arquivos Figma/Sketch para criar um protótipo primeiro',
  'We only translated a small part of the template, for demonstration purposes':
    'Traduzimos apenas uma pequena parte do modelo, para fins de demonstração',
  'Sign in': 'Login',
  'Fill in the fields below to sign into your account.':
    'Preencha os campos abaixo para entrar na sua conta',
  'Lost password?': 'Esqueceu a senha?',
  'I accept the': 'Aceite os',
  'terms and conditions': 'Termos e Condições de uso.',
  'Don’t have an account, yet?': 'Não possui conta?',
  'Sign up here': 'Clique aqui',
  'Email address': 'Email',
  Password: 'Senha',
  'Types of Registers': 'Tipos de Registros',
  'Start Date': 'Data Início',
  'Finish Date': 'Data Fim',
  'Freeze date': 'Data Congelamento',
  "Beneficiary's name": 'Nome do Beneficiário',
  Beneficiary: 'Beneficiário',
  'Cellphone must be 11 digits': 'O celular tem que ter 11 dígitos',
  'Error creating user':
    'Ocorreu um erro ao criar o usuário, verifique os dados e tente novamente',
  Matriculation: 'Matricula',
  'Only singles example MG': 'Apenas siglas exemplo MG',
  jobtitle: 'Cargo',
  'The user account was created successfully':
    'A conta de usuário foi criada com sucesso',
  Roles: 'Perfis',
  'CPF must be 11 digits': 'CPF precisa ter 11 dígitos',
  'invalid CPF': 'CPF inválido',
  'The email provided should be a valid email address':
    'O e-mail fornecido deve ser um endereço de e-mail válido',
  Value: 'Valor',
  'Write value...': 'Escreva um valor',
  Observation: 'Observação',
  CLIENT: 'CLIENTE',
  'Required field': 'Campo Obrigatório',
  'Invalid date': 'Data Inválida',
  'Write a observetion': 'Escreva uma observação',
  'There is an error': 'Ocorreu um erro',
  'The parameter was created successfully':
    'O parâmetro foi criado com sucesso',
  'Please try again': 'Por favor, tente novamente',
  'Freezing age': 'Congelamento Idade',
  'Judicial decision': 'Decisão Judicial',
  "We couldn't find any parameters matching your search criteria":
    'Não encontramos nenhum parâmetro que corresponda aos seus critérios de pesquisa',
  'Register Type': 'Tipo de Registro',
  All: 'Todos',
  all: 'Todos',
  Filter: 'Filtrar',
  Filters: 'Filtros',
  'Export CSV': 'Exportar CSV',
  Column: 'Coluna',
  Operator: 'Operador',
  'Add filter': 'Adicionar filtro',
  Contains: 'Contém',
  Equals: 'Igual a',
  'Not equals': 'Diferente de',
  'Starts with': 'Começa com',
  'Ends with': 'Termina com',
  'Search by Start Date, Finish, Free ou Matriculation...':
    'Procure por Data Início, Fim, Congelamento ou Matricula',
  'Expired Login': 'Login Expirado',
  'Laboratory - Management': 'Laboratório - Gerenciamento',
  'Company Name': 'Razão Social',
  Consultant: 'Consultor',
  'The laboratory has been removed': 'O laboratório foi removido',
  'The laboratory was created successfully':
    'O laboratório foi criado com sucesso',
  'Error creating laboratory': 'Ocorreu um erro ao criar o laboratório',
  'Search by company name, code, cnpj or consultant...':
    'Pesquisar por nome da empresa, código, cnpj ou consultor...',
  "We couldn't find any laboratory matching your search criteria":
    'Não encontramos nenhum laboratório que corresponda aos seus critérios de pesquisa',
  'Select all laboratories': 'Selecionar todos os laboratórios',
  laboratories: 'laboratórios',
  laboratory: 'laboratório',
  'laboratory code': 'Código do laboratório',
  'Choose between table or grid views for displaying the users list.':
    'Escolha entre tabela ou grade para exibir a lista de usuários.',
  'Choose between table or grid views for displaying the laboratories list.':
    'Escolha entre tabela ou grade para exibir a lista de laboratórios.',
  'Are you sure you want to permanently delete this user account':
    ' Você tem certeza de que deseja excluir permanentemente esta conta de usuário',
  'Are you sure you want to permanently delete this laboratory':
    'Você tem certeza de que deseja excluir permanentemente este laboratório',
  'Rows per page': 'Linhas por página',
  Laboratories: 'Laboratórios',
  'Roles in': 'Perfis em',
  'No role: the user will have no permissions in this laboratory':
    'Sem perfil: o usuário não terá permissões neste laboratório',
  'Laboratories Management': 'Gerenciamento de Laboratórios',
  'All aspects related to the app laboratories can be managed from this page':
    'Todos os aspectos relacionados aos laboratórios do aplicativo podem ser gerenciados nesta página',
  'Create laboratory': 'Criar laboratório',
  'Add new laboratory': 'Adicionar novo laboratório',
  'Fill in the fields below to create and add a new laboratory':
    'Preencha os campos abaixo para criar e adicionar um novo laboratório',
  'Credentials Shift (Optional)': 'Credenciais Shift (Opcional)',
  'Credentials Shift': 'Credenciais Shift',
  'Credential User': 'Usuário da Credencial',
  'Credential Password': 'Senha da Credencial',
  'Shift system credentials': 'Credenciais do sistema Shift',
  'ShiftELIS Credentials': 'Credenciais do ShiftELIS',
  'ShiftELIS Username': 'Usuário do ShiftELIS',
  'ShiftELIS Password': 'Senha do ShiftELIS',
  'Leave empty to use the laboratory credential':
    'Deixe em branco para usar a credencial do laboratório',
  'Leave empty to keep the current password':
    'Deixe em branco para manter a senha atual',
  Code: 'Código',
  'Invalid status': 'Status inválido',
  'invalid CNPJ': 'CNPJ inválido',
  'CNPJ must be 14 digits': 'CNPJ tem que ter 14 dígitos',
  Delete: 'Excluir',
  Laboratory: 'Laboratório',
  'General Information': 'Informações Gerais',
  Contact: 'Contato',
  Audit: 'Auditoria',
  'Details about the laboratory': 'Detalhes sobre o laboratório',
  'Details about how to contact the laboratory':
    'Detalhes sobre como entrar em contato com o laboratório',
  'Details about who created and updated this record':
    'Detalhes sobre quem criou e atualizou este registro',
  Cellphone: 'Celular',
  'Created By': 'Criado por',
  'Created At': 'Criado em',
  'Updated By': 'Atualizado por',
  'Updated At': 'Atualizado em',
  'Last Login At': 'Último login em',
  'Never logged in': 'Nunca fez login',
  'The email field is required': 'O campo de e-mail é obrigatório',
  'The password field is required': 'O campo de senha é obrigatório',
  'At least one role is required': 'Pelo menos um perfil é obrigatório',
  'Analytics Dashboard': 'Painel de Controle de Análise',
  'Personal Details': 'Detalhes Pessoais',
  'Manage informations related to personal details':
    'Gerenciar informações relacionadas aos detalhes pessoais',
  'Contact Information': 'Informações de Contato',
  'Details about how to contact the user':
    'Detalhes sobre como entrar em contato com o usuário',
  'Status and Role': 'Status e perfil',
  "Details about the user's status and role":
    'Detalhes sobre o status e a perfil do usuário',
  'The user was removed successfully': 'O usuário foi removido com sucesso',
  'Error removing user': 'Ocorreu um erro ao remover o usuário',
  'The user was updated successfully': 'O usuário foi atualizado com sucesso',
  "Details about the user's laboratory":
    'Detalhes sobre o laboratório do usuário',
  'Job Title': 'Cargo',
  View: 'Visualizar',
  'Go to': 'Ir para',
  'Details about the laboratory address':
    'Detalhes sobre o endereço do laboratório',
  'The full name must not contain numbers':
    'O nome completo não pode conter números',
  'The full name must contain at least two words':
    'O nome completo deve conter pelo menos duas palavras',
  'Password must contain at least one special character':
    'Senha deve conter pelo menos um caractere especial',
  'Password must contain at least one number':
    'Senha deve conter pelo menos um número',
  'Password must be at most 100 characters long':
    'A senha deve ter no máximo 100 caracteres de comprimento',
  'Password must be at least 8 characters long':
    'Senha deve ter pelo menos 8 caracteres de comprimento',
  Edit: 'Editar',
  'Error edit laboratory':
    'Ocorreu um erro ao editar o laboratório, verifique os dados e tente novamente',
  'Edit laboratory': 'Editar laboratório',
  'Edit laboratory information': 'Editar informações do laboratório',
  'Edit user': 'Editar usuário',
  'Edit user information': 'Editar informações do usuário',
  'Error edit user':
    'Ocorreu um erro ao editar o usuário, verifique os dados e tente novamente',
  'The laboratory was updated successfully':
    'O laboratório foi atualizado com sucesso',
  'External Links': 'Links Externos',
  'Useful Links': ' Links Úteis',
  'Here you can find links to various resources and tools that can help you in your work':
    'Aqui você encontra links para diversos recursos e ferramentas que podem ajudá-lo em seu trabalho',
  'Access Control': 'Controle de Acesso',
  'The role has been removed': 'O perfil foi removido',
  'The role was created successfully': 'O perfil foi criado com sucesso',
  'Error creating role': 'Ocorreu um erro ao criar o perfil',
  'Role Name': 'Nome do Perfil',
  'Search by role name...': 'Pesquisar por nome do perfil...',
  "We couldn't find any roles matching your search criteria":
    'Não encontramos nenhum perfil que corresponda aos seus critérios de pesquisa',
  'Select all roles': 'Selecionar todos os perfis',
  'Roles Management': 'Gerenciamento de Perfis',
  'Choose between table or grid views': 'Escolha entre tabela ou grade',
  'Are you sure you want to permanently delete this role':
    'Você tem certeza de que deseja excluir permanentemente este perfil',
  'Manage your roles, and permissions to control access to resources':
    'Gerencie seus perfis e permissões para controlar o acesso aos recursos',
  'Create role': 'Criar perfil',
  'Read User': 'Ler Usuário',
  'Allows reading user information': 'Permite ler informações do usuário',
  'Update User': 'Atualizar Usuário',
  'Allows updating user information':
    'Permite atualizar informações do usuário',
  'Create User': 'Criar Usuário',
  'Allows creating new users': 'Permite criar novos usuários',
  'Delete User': 'Excluir Usuário',
  'Allows deleting users': 'Permite excluir usuários',
  'Read Laboratory': 'Ler Laboratório',
  'Allows reading laboratory information':
    'Permite ler informações do laboratório',
  'Update Laboratory': 'Atualizar Laboratório',
  'Allows updating laboratory information':
    'Permite atualizar informações do laboratório',
  'Create Laboratory': 'Criar Laboratório',
  'Allows creating new laboratories': 'Permite criar novos laboratórios',
  'Delete Laboratory': 'Excluir Laboratório',
  'Allows deleting laboratories': 'Permite excluir laboratórios',
  'Read Role': 'Ler perfil',
  'Allows reading role information': 'Permite ler informações do perfil',
  'Update Role': 'Atualizar perfil',
  'Allows updating role information': 'Permite atualizar informações do perfil',
  'Create Role': 'Criar perfil',
  'Allows creating new roles': 'Permite criar novas funções',
  'Delete Role': 'Excluir perfil',
  'Allows deleting roles': 'Permite excluir funções',
  'No description available': 'Nenhuma descrição disponível',
  'Role Description': 'Descrição do Perfil',
  'Add new role': 'Adicionar novo perfil',
  'Fill in the fields below to create and add a new role':
    'Preencha os campos abaixo para criar e adicionar um novo perfil',
  Permissions: 'Permissões',
  'Role name is required': 'O nome do perfil é obrigatório',
  'Role name must be at least 3 characters':
    'O nome do perfil deve ter pelo menos 3 caracteres',
  'Role name must not exceed 50 characters':
    'O nome do perfil não deve exceder 50 caracteres',
  'Permission ID is required': 'O ID da permissão é obrigatório',
  'At least one permission must be selected':
    'Pelo menos uma permissão deve ser selecionada',
  'Permissions are required': 'As permissões são obrigatórias',
  'Role created successfully': 'Perfil criado com sucesso',
  'View/Edit': 'Visualizar/Editar',
  'Role Details': 'Detalhes do Perfil',
  'Manage informations related to role details':
    'Gerencie informações relacionadas aos detalhes do perfil',
  'Edit role': 'Editar perfil',
  'Edit role information': 'Editar informações do perfil',
  'Role updated successfully': 'perfil atualizado com sucesso',
  'Error update role': 'Erro ao atualizar perfil',
  'Role deleted successfully': 'Perfil excluído com sucesso',
  'Error deleting role': 'Erro ao excluir perfil',
  'Are you sure you want to delete this role?':
    'Você tem certeza de que deseja excluir este perfil?',
  'User deleted successfully': 'Usuário excluído com sucesso',
  'Error deleting user': 'Erro ao excluir usuário',
  'Are you sure you want to delete this user?':
    'Você tem certeza de que deseja excluir este usuário?',
  'Are you sure you want to delete this laboratory?':
    'Você tem certeza de que deseja excluir este laboratório?',
  'Laboratory deleted successfully': 'Laboratório excluído com sucesso',
  'Error deleting laboratory': 'Erro ao excluir laboratório',
  'Code must be unique': 'O código deve ser único',
  'CNPJ must be unique': 'O CNPJ deve ser único',
  Communicate: 'Comunicado',
  Informative: 'Informativo',
  ACTIVE: 'ATIVO',
  INACTIVE: 'INATIVO',
  'Recipient Groups': 'Grupos de Destinatários',
  'Create Recipient Group': 'Criar Grupo de Destinatários',
  'Add new recipient group': 'Adicionar novo grupo de destinatários',
  'Fill in the fields below to create and add a new recipient group':
    'Preencha os campos abaixo para criar e adicionar um novo grupo de destinatários',
  'Group Name': 'Nome do Grupo',
  'Search by group name...': 'Pesquisar por nome do grupo...',
  "We couldn't find any recipient groups matching your search criteria":
    'Não encontramos nenhum grupo de destinatários que corresponda aos seus critérios de pesquisa',
  'Select all recipient groups': 'Selecionar todos os grupos de destinatários',
  'Recipient Groups Management': 'Gerenciamento de Grupos de Destinatários',
  'Are you sure you want to permanently delete this recipient group':
    'Você tem certeza de que deseja excluir permanentemente este grupo de destinatários',
  'Manage your recipient groups to organize and target your communications effectively':
    'Gerencie seus grupos de destinatários para organizar e direcionar suas comunicações de forma eficaz',
  'Recipients Management': 'Gerenciamento de Destinatários',
  'Manage your recipients to ensure effective communication and engagement':
    'Gerencie seus destinatários para garantir uma comunicação e engajamento eficazes',
  Recipients: 'Destinatários',
  'Manage recipients for your communications':
    'Gerenciar destinatários para suas comunicações',
  'Create Recipient': 'Criar Destinatário',
  'Add new recipient': 'Adicionar novo destinatário',
  'Fill in the fields below to create and add a new recipient':
    'Preencha os campos abaixo para criar e adicionar um novo destinatário',
  'Search by name or email...': 'Pesquisar por nome ou e-mail...',
  "We couldn't find any recipients matching your search criteria":
    'Não encontramos nenhum destinatário que corresponda aos seus critérios de pesquisa',
  'Select all recipients': 'Selecionar todos os destinatários',
  'Choose between table or grid views for displaying the recipient groups list.':
    'Escolha entre tabela ou grade para exibir a lista de grupos de destinatários.',
  'Choose between table or grid views for displaying the recipients list.':
    'Escolha entre tabela ou grade para exibir a lista de destinatários.',
  'Are you sure you want to permanently delete this recipient':
    'Você tem certeza de que deseja excluir permanentemente este destinatário',
  'Manage your roles and permissions to control access to resources':
    'Gerencie seus perfis e permissões para controlar o acesso aos recursos',
  'Create recipient group': 'Criar grupo de destinatários',
  'Group name is required': 'O nome do grupo é obrigatório',
  'Group name must be at least 3 characters':
    'O nome do grupo deve ter pelo menos 3 caracteres',
  'Group name must not exceed 50 characters':
    'O nome do grupo não deve exceder 50 caracteres',
  'Recipient group created successfully':
    'Grupo de destinatários criado com sucesso',
  'Recipient group deleted successfully':
    'Grupo de destinatários excluído com sucesso',
  'Error deleting recipient group': 'Erro ao excluir grupo de destinatários',
  'Are you sure you want to delete this recipient group?':
    'Você tem certeza de que deseja excluir este grupo de destinatários?',
  'Recipient deleted successfully': 'Destinatário excluído com sucesso',
  'Error deleting recipient': 'Erro ao excluir destinatário',
  'Are you sure you want to delete this recipient?':
    'Você tem certeza de que deseja excluir este destinatário?',
  'The recipient was created successfully':
    'O destinatário foi criado com sucesso',
  'Error creating recipient': 'Ocorreu um erro ao criar o destinatário',
  'Manage groups of recipients for your communications':
    'Gerenciar grupos de destinatários para suas comunicações',
  'Group Details': 'Detalhes do Grupo',
  'Manage informations related to recipient group details':
    'Gerencie informações relacionadas aos detalhes do grupo de destinatários',
  'Edit recipient group': 'Editar grupo de destinatários',
  'Edit recipient group information':
    'Editar informações do grupo de destinatários',
  'Recipient group updated successfully':
    'Grupo de destinatários atualizado com sucesso',
  'Create Group': 'Criar Grupo',
  Active: 'Ativo',
  Inactive: 'Inativo',
  StatusFilter: 'Filtro de Status',
  'Manage your email templates for communications':
    'Gerenciar seus modelos de e-mail para comunicações',
  'Create Template': 'Criar Template',
  'Recipients - Management': 'Destinatários - Gerenciamento',
  'Recipient updated successfully': 'Destinatário atualizado com sucesso',
  'Save Changes': 'Salvar Alterações',
  'Edit Recipient': 'Editar Destinatário',
  'Recipient Details': 'Detalhes do Destinatário',
  'Manage informations related to recipient details':
    'Gerencie informações relacionadas aos detalhes do destinatário',
  'Edit recipient information': 'Editar informações do destinatário',
  Recipient: 'Destinatário',
  Created: 'Criado',
  'Fill in the information below to create a new recipient':
    'Preencha as informações abaixo para criar um novo destinatário',
  'Add Users': 'Adicionar Usuários',
  'Add Recipient Groups': 'Adicionar Grupos de Destinatários',
  Group: 'Grupo',
  'Add Laboratories': 'Adicionar Laboratórios',
  'Relate Recipients to Communication':
    'Relacionar Destinatários à Comunicação',
  'No members selected. Use the buttons above to add users or laboratories.':
    'Nenhum membro selecionado. Use os botões acima para adicionar usuários ou laboratórios.',
  'Releate Recipients': 'Relacionar Destinatários',
  'No recipients selected': 'Nenhum destinatário selecionado',
  'Remove All': 'Remover Todos',
  'Group Members': 'Membros do Grupo',
  'Use the buttons above to add users, laboratories, or recipients to this group.':
    'Use os botões acima para adicionar usuários, laboratórios ou destinatários a este grupo.',
  'No members selected': 'Nenhum membro selecionado',
  Description: 'Descrição',
  Type: 'Tipo',
  Member: 'Membro',
  'Static group members': 'Membros do grupo estático',
  'Group Information': 'Informações do Grupo',
  'Total Members': 'Total de Membros',
  sent: 'enviado',
  Sent: 'Enviado',
  scheduled: 'agendado',
  Scheduled: 'Agendado',
  draft: 'rascunho',
  Draft: 'Rascunho',
  failed: 'falhou',
  Failed: 'Falhado',
  'Email Configuration': 'Configuração de E-mail',
  Subject: 'Assunto',
  Template: 'Template',
  'No template': 'Sem template',
  Content: 'Conteúdo',
  'Recipient Selection Type': 'Tipo de Seleção de Destinatários',
  'Status & Statistics': 'Status e Estatísticas',
  'Not set': 'Não definido',
  recipients: 'destinatários',
  emails: 'e-mails',
  Delivered: 'Entregue',
  Opened: 'Aberto',
  'Sent at': 'Enviado em',
  'Scheduled for': 'Agendado para',
  'Created by': 'Criado por',
  System: 'Sistema',
  'Template Variables': 'Variáveis do Template',
  'Recipient Criteria': 'Critérios do Destinatário',
  Preview: 'Visualizar',
  'Email Template': 'Template de Email',
  'Basic Information': 'Informações Básicas',
  'Add Recipients': 'Adicionar Destinatários',
  User: 'Usuário',
  'An error occurred while trying to recover the password. Please try again later.':
    'Ocorreu um erro ao tentar recuperar a senha. Por favor, tente novamente mais tarde.',
  'Reset Password': 'Redefinir Senha',
  'New Password': 'Nova Senha',
  'Confirm Password': 'Confirmar Senha',
  'An error occurred while resetting the password':
    'Ocorreu um erro ao redefinir a senha',
  'Password reset successfully': 'Senha redefinida com sucesso',
  'Populate the area and subject fields to open a help desk ticket':
    'Preencha os campos de área e assunto para abrir um chamado na central de ajuda',
  'Fill in the fields below to reset your password.':
    'Preencha os campos abaixo para redefinir sua senha.',
  'Send me a new password': 'Me envie uma nova senha',
  'Enter the email used for registration to reset your password.':
    'Digite o e-mail usado para o registro para redefinir sua senha.',
  'The password reset instructions have been sent to your email':
    'As instruções para redefinir a senha foram enviadas para o seu e-mail',
  'Check your email for further instructions':
    'Verifique seu e-mail para mais instruções',
  'Continue to login': 'Continuar para o login',
  File: 'Arquivo',
  Files: 'Arquivos',
  file: 'arquivo',
  files: 'arquivos',
  DOCUMENT: 'DOCUMENTO',
  'Manage all the files uploaded to the system from here.':
    'Gerencie todos os arquivos enviados para o sistema a partir daqui.',
  'Add new file': 'Adicionar novo arquivo',
  'Fill in the fields below to create and add a new file':
    'Preencha os campos abaixo para criar e adicionar um novo arquivo',
  'Search by file name or type...': 'Pesquisar por nome ou tipo de arquivo...',
  "We couldn't find any files matching your search criteria":
    'Não encontramos nenhum arquivo que corresponda aos seus critérios de pesquisa',
  'Select all files': 'Selecionar todos os arquivos',
  'Upload File': 'Subir Arquivo',
  'File Name': 'Nome do Arquivo',
  Download: 'Baixar',
  'Upload Document': 'Subir Arquivo',
  'Display Name': 'Nome',
  'Document Type': 'Tipo de Documento',
  All: 'Todos',
  Documentos: 'Documentos',
  Certificados: 'Certificados',
  'Formulários': 'Formulários',
  'Please select a document type': 'Por favor, selecione o tipo de documento',
  'Read File': 'Ler Arquivo',
  'Update File': 'Atualizar Arquivo',
  'Create File': 'Criar Arquivo',
  'Delete File': 'Excluir Arquivo',
  'Allows updating file information':
    'Permite atualizar informações do arquivo',
  'Allows reading file information': 'Permite ler informações do arquivo',
  'Allows creating new files': 'Permite criar novos arquivos',
  'Allows deleting files': 'Permite excluir arquivos',
  'Read Communications': 'Ler comunicados',
  'Allows reading of communications': 'Permite ler informações de comunicação',
  'Update Communication': 'Atualizar Comunicação',
  'Allows updating communication information':
    'Permite atualizar informações de comunicação',
  'Create Communications': 'Criar Comunicados',
  'Allows creating communications': 'Permite criar novas comunicados',
  'Delete Communications': 'Excluir Comunicados',
  'Allow deleting communications': 'Permite excluir comunicados',
  'Read Email Template': 'Ler Template de E-mail',
  'Allows reading of email templates':
    'Permite ler informações do template de e-mail',
  'Update Email Template': 'Atualizar Template de E-mail',
  'Allows updating email template information':
    'Permite atualizar informações do template de e-mail',
  'Create Email Template': 'Criar Template de E-mail',
  'Allows creating email templates': 'Permite criar novos templates de e-mail',
  'Delete Email Template': 'Excluir Template de E-mail',
  'Allows deleting email templates': 'Permite excluir templates de e-mail',
  'Read recipient': 'Ler destinatário',
  'Update recipient': 'Atualizar destinatário',
  'Create recipient': 'Criar destinatário',
  'Delete recipient': 'Excluir destinatário',
  'Allows reading of recipients': 'Permite ler informações dos destinatários',
  'Allows updating recipient information':
    'Permite atualizar informações do destinatário',
  'Allows creating recipients': 'Permite criar novos destinatários',
  'Allows deleting recipients': 'Permite excluir destinatários',
  'Read Recipient Groups': 'Ler Grupos de Destinatários',
  'Allows reading of recipient groups':
    'Permite ler informações dos grupos de destinatários',
  'Update Recipient Group': 'Atualizar Grupo de Destinatários',
  'Allows updating recipient group information':
    'Permite atualizar informações do grupo de destinatários',
  'Create Recipient Groups': 'Criar Grupo de Destinatários',
  'Allows creating recipient groups':
    'Permite criar novos grupos de destinatários',
  'Delete Recipient Group': 'Excluir Grupo de Destinatários',
  'Allows deleting recipient groups': 'Permite excluir grupos de destinatários',
  'Upload a document to your repository': 'Envie um documento',
  'Click to select a file': 'Clique para selecionar um arquivo',
  'or drag and drop': 'ou arraste e solte',
  'Template ID not found': 'ID do template não encontrado',
  'Please enter a valid phone number. Use the format (XX) XXXXX-XXXX for mobile phones or (XX) XXXX-XXXX for landlines':
    'Por favor, insira um número de telefone válido. Use o formato (XX) XXXXX-XXXX para celulares ou (XX) XXXX-XXXX para telefones fixos',

  // Financial - Invoices
  'Manage all issued invoices': 'Gerencie todas as notas fiscais emitidas',
  'Upload Invoices': 'Enviar Notas Fiscais',
  'Upload XML and PDF invoice files. You can select multiple files at once.':
    'Envie arquivos de nota fiscal XML e PDF. Você pode selecionar vários arquivos de uma vez.',
  'File "{{name}}" has an invalid extension. Only XML and PDF files are allowed.':
    'O arquivo "{{name}}" possui uma extensão inválida. Somente arquivos XML e PDF são permitidos.',
  'Please select at least one file':
    'Por favor, selecione pelo menos um arquivo',
  'Error uploading invoices': 'Erro ao enviar notas fiscais',
  'Click to select XML and PDF files':
    'Clique para selecionar arquivos XML e PDF',
  'Only .xml and .pdf files are accepted':
    'Somente arquivos .xml e .pdf são aceitos',
  'Selected files': 'Arquivos selecionados',
  'Uploading invoices...': 'Enviando notas fiscais...',
  'Uploading...': 'Enviando...',
  Upload: 'Enviar',
  'Invoice Number': 'Número da Nota Fiscal',
  Company: 'Empresa',
  'Search by invoice number, competence or CNPJ...':
    'Pesquisar por número da nota fiscal, competência ou CNPJ...',
  "We couldn't find any invoices matching your search criteria":
    'Não encontramos nenhuma nota fiscal correspondente aos seus critérios de pesquisa',
  financial: 'financeiro',
  Financial: 'Financeiro',
  'Read Financial': 'Ler Financeiro',
  'Allows reading financial data': 'Permite ler dados financeiros',
  'Read Invoice': 'Ler Nota Fiscal',
  'Allows reading invoice data': 'Permite ler dados de nota fiscal',
  'Create Invoice': 'Criar Nota Fiscal',
  'Allows creating invoice data': 'Permite criar dados de nota fiscal',
  Extension: 'Extensão',
  Competence: 'Competência',
  'Read Ticket': 'Ler Chamados',
  'Create Ticket': 'Criar Chamado',
  'Allows reading ticket': 'Permite ler dados de chamado',
  'Allows creating ticket': 'Permite criar dados de chamado',
  'Search permissions...': 'Pesquisar permissões...',
  'Invoice deleted successfully': 'Nota fiscal excluída com sucesso',
  'Invoices deleted successfully': 'Notas fiscais excluídas com sucesso',
  'Error deleting invoice(s)': 'Erro ao excluir nota(s) fiscal(is)',
  'Are you sure you want to delete this invoice?':
    'Você tem certeza de que deseja excluir esta nota fiscal?',
  'Are you sure you want to delete {{count}} invoices?':
    'Você tem certeza de que deseja excluir {{count}} notas fiscais?',
  'Error downloading invoice': 'Erro ao baixar a nota fiscal',
  '{{count}} invoice(s) processed successfully': '{{count}} nota(s) processada(s) com sucesso',
  '{{count}} invoice(s) failed': '{{count}} nota(s) com erro',
  'Upload more': 'Enviar mais',
  'Resend password email': 'Reenviar email de senha',
  'Are you sure you want to resend the password email to this user?':
    'Tem certeza que deseja reenviar o email de senha para este usuário?',
  Resend: 'Reenviar',
  'Password recovery email sent successfully': 'Email de recuperação de senha enviado com sucesso',
  'Error sending password recovery email': 'Erro ao enviar email de recuperação de senha',
  'File deleted successfully': 'Arquivo excluído com sucesso',
  'Files deleted successfully': 'Arquivos excluídos com sucesso',
  'Error deleting file(s)': 'Erro ao excluir arquivo(s)',
  'Are you sure you want to delete this file?':
    'Você tem certeza de que deseja excluir este arquivo?',
  'Are you sure you want to delete {{count}} files?':
    'Você tem certeza de que deseja excluir {{count}} arquivos?',
  'Only administrators can edit the CPF':
    'Somente administradores podem editar o CPF',
  'CPF already registered for another user':
    'CPF já cadastrado para outro usuário',

  // Financial - Boletos
  Boletos: 'Boletos',
  'Manage boletos generated from bank return files':
    'Gerencie os boletos gerados a partir dos arquivos de retorno bancário',
  'Upload Return File': 'Enviar Arquivo de Retorno',
  'Upload Boleto Return (.RET)': 'Enviar Retorno de Boleto (.RET)',
  'Upload a bank return file, review the suggested laboratory for each bill and confirm before publishing.':
    'Envie um arquivo de retorno bancário, revise o laboratório sugerido para cada título e confirme antes de publicar.',
  "We couldn't find any boletos matching your search criteria":
    'Não encontramos nenhum boleto correspondente aos seus critérios de pesquisa',
  'Click to select a .RET file': 'Clique para selecionar um arquivo .RET',
  'Only .RET (CNAB return) files are accepted':
    'Somente arquivos .RET (retorno CNAB) são aceitos',
  'Error reading the return file': 'Erro ao ler o arquivo de retorno',
  'Reading {{name}}...': 'Lendo {{name}}...',
  '{{assigned}} of {{total}} bills associated to a laboratory':
    '{{assigned}} de {{total}} títulos associados a um laboratório',
  'Payer (sacado)': 'Sacado',
  'Due date': 'Vencimento',
  Amount: 'Valor',
  Suggestion: 'Sugestão',
  None: 'Nenhum',
  'Select laboratory': 'Selecionar laboratório',
  'Associate at least one bill to a laboratory before confirming':
    'Associe pelo menos um título a um laboratório antes de confirmar',
  'Confirming...': 'Confirmando...',
  'Confirm {{count}} boleto(s)': 'Confirmar {{count}} boleto(s)',
  'Error confirming boletos': 'Erro ao confirmar boletos',
  '{{count}} boleto(s) confirmed successfully':
    '{{count}} boleto(s) confirmado(s) com sucesso',
  '{{count}} boleto(s) failed': '{{count}} boleto(s) com erro',
  'Upload another file': 'Enviar outro arquivo',
  'Choose another file': 'Escolher outro arquivo',
  Close: 'Fechar',
  CNPJ: 'CNPJ',
  'Copy digitable line': 'Copiar linha digitável',
  'Download PDF': 'Baixar PDF',
  'Error downloading boleto': 'Erro ao baixar o boleto',
  'Search by payer, CNPJ or competence...':
    'Pesquisar por sacado, CNPJ ou competência...',
  'Search by payer, CNPJ, lab. code or competence...':
    'Pesquisar por sacado, CNPJ, código do laboratório ou competência...',
  'Lab. code': 'Código do laboratório',
  'Read Boleto': 'Ler Boleto',
  'Allows reading boleto data': 'Permite ler dados de boleto',
  'Create Boleto': 'Criar Boleto',
  'Allows uploading and confirming boleto batches':
    'Permite enviar e confirmar lotes de boletos',

  // Financial - Boletos - associacao por CNPJ (REM/RET)
  'Enviar REM': 'Enviar REM',
  'Enviar Retorno': 'Enviar Retorno',
  'Manual review (legacy)': 'Revisão manual (legado)',
  'Click to select or drag .REM files':
    'Clique para selecionar ou arraste arquivos .REM',
  'Click to select or drag .RET files':
    'Clique para selecionar ou arraste arquivos .RET',
  'Multiple files accepted': 'Múltiplos arquivos aceitos',
  'Upload Boleto Remessa (.REM)': 'Enviar Remessa de Boleto (.REM)',
  'Associates titles by CNPJ and automatically resolves any title that was waiting for this remessa.':
    'Associa títulos pelo CNPJ e resolve automaticamente qualquer título que estava aguardando esta remessa.',
  '{{total}} title(s) read - {{created}} new, {{reprocessed}} resolved automatically':
    '{{total}} título(s) lido(s) - {{created}} novo(s), {{reprocessed}} resolvido(s) automaticamente',
  '{{total}} title(s) - {{created}} new, {{reprocessed}} resolved':
    '{{total}} título(s) - {{created}} novo(s), {{reprocessed}} resolvido(s)',
  '{{count}} file(s) failed': '{{count}} arquivo(s) com erro',
  'Upload more files': 'Enviar mais arquivos',
  'Upload Boleto Return (.RET) - CNPJ association':
    'Enviar Retorno de Boleto (.RET) - associação por CNPJ',
  'Associates and emits each title by CNPJ (strong key) - never by payer name. Titles without a known CNPJ show up under Pending titles below.':
    'Associa e emite cada título pelo CNPJ (chave forte) - nunca pelo nome do sacado. Títulos sem CNPJ conhecido aparecem em Títulos pendentes abaixo.',
  '{{total}} title(s) read - {{associated}} associated and emitted, {{awaitingRem}} awaiting remessa, {{manualReview}} need manual review':
    '{{total}} título(s) lido(s) - {{associated}} associado(s) e emitido(s), {{awaitingRem}} aguardando remessa, {{manualReview}} precisam de revisão manual',
  '{{total}} title(s) - {{associated}} associated, {{awaitingRem}} awaiting, {{manualReview}} manual review':
    '{{total}} título(s) - {{associated}} associado(s), {{awaitingRem}} aguardando, {{manualReview}} revisão manual',
  'Pending titles': 'Títulos pendentes',
  'Retorno occurrences without a confirmed CNPJ yet - amber waits for the remessa, red needs a manual decision.':
    'Ocorrências de retorno sem CNPJ confirmado ainda - âmbar aguarda a remessa, vermelho precisa de decisão manual.',
  'Seu numero': 'Seu número',
  'Nosso numero': 'Nosso número',
  'Resolve title manually': 'Resolver título manualmente',
  'The payer name below is only a visual hint - it never decides the association by itself.':
    'O nome do sacado abaixo é só uma dica visual - nunca decide a associação sozinho.',
  'Suggestion: {{name}}': 'Sugestão: {{name}}',
  'Error resolving this title': 'Erro ao resolver este título',
  'Resolving...': 'Resolvendo...',
  Resolve: 'Resolver',
  'Awaiting remessa': 'Aguardando REM',
  'Manual review': 'Revisão manual',
  Associated: 'Associado',
  'Awaiting return': 'Aguardando retorno',
  'Are you sure you want to delete this boleto? It will stop appearing in this list and for the laboratory.':
    'Tem certeza que deseja excluir este boleto? Ele deixará de aparecer nesta listagem e para o laboratório.',
  'Are you sure you want to delete {{count}} boleto(s)? They will stop appearing in this list and for the corresponding laboratories.':
    'Tem certeza que deseja excluir {{count}} boleto(s)? Eles deixarão de aparecer nesta listagem e para os laboratórios correspondentes.',
  'Boleto deleted successfully': 'Boleto excluído com sucesso',
  '{{count}} boleto(s) deleted successfully':
    '{{count}} boleto(s) excluído(s) com sucesso',
  'Error deleting boleto(s)': 'Erro ao excluir boleto(s)',
  'Are you sure you want to delete this title? It will stop appearing in this list - if a matching REM or RET arrives later, a new title will be created for it.':
    'Tem certeza que deseja excluir este título? Ele deixará de aparecer nesta listagem - se um REM ou RET correspondente chegar depois, um novo título será criado para ele.',
  'Are you sure you want to delete {{count}} title(s)? They will stop appearing in this list - if a matching REM or RET arrives later, a new title will be created for it.':
    'Tem certeza que deseja excluir {{count}} título(s)? Eles deixarão de aparecer nesta listagem - se um REM ou RET correspondente chegar depois, um novo título será criado para ele.',
  'Title deleted successfully': 'Título excluído com sucesso',
  '{{count}} title(s) deleted successfully':
    '{{count}} título(s) excluído(s) com sucesso',
  'Error deleting title(s)': 'Erro ao excluir título(s)',
  Save: 'Salvar',
  'Saving...': 'Salvando...',
  'Default instructions': 'Instruções padrão',
  'Used on every boleto that has no instructions of its own - editable per boleto from its row menu.':
    'Usada em todo boleto que não tem uma instrução própria - editável por boleto no menu da linha.',
  'Instructions shown on the boleto PDF...':
    'Instruções exibidas no PDF do boleto...',
  'Default instructions updated successfully':
    'Instruções padrão atualizadas com sucesso',
  'Error updating default instructions': 'Erro ao atualizar instruções padrão',
  'Boleto instructions': 'Instruções do boleto',
  'Leave blank to use the module default instructions instead.':
    'Deixe em branco para usar a instrução padrão do módulo.',
  'Instructions updated successfully': 'Instruções atualizadas com sucesso',
  'Error updating instructions': 'Erro ao atualizar instruções',
  'Edit instructions': 'Editar instruções',
  'Default instructions updated - affected PDFs will be refreshed on their next download':
    'Instrução padrão atualizada - os PDFs afetados serão atualizados no próximo download de cada um',
  'Instructions updated - the PDF will be refreshed on its next download':
    'Instruções atualizadas - o PDF será atualizado no próximo download',

  // Financial - Boletos - inclusão manual
  'Import files': 'Importar arquivos',
  'Manual entry': 'Inclusão manual',
  'Manual entry badge': 'Inclusão Manual',
  'Edit boleto': 'Editar boleto',
  'Edit manual boleto': 'Editar boleto manual',
  'Boleto created successfully': 'Boleto cadastrado com sucesso',
  'Boleto updated successfully': 'Boleto atualizado com sucesso',
  'Error saving boleto': 'Erro ao salvar boleto',
  'Manual boletos are registered one at a time and must belong to a laboratory.':
    'Boletos manuais são cadastrados um por vez e precisam pertencer a um laboratório.',
  'Digitable line / barcode': 'Linha digitável / Código de barras',
  'Searching laboratory...': 'Buscando laboratório...',
  'No laboratory is linked to this CNPJ': 'Nenhum laboratório vinculado a este CNPJ',
  'Pick a registered laboratory or type a CNPJ':
    'Escolha um laboratório cadastrado ou digite um CNPJ',
  'Invalid CNPJ': 'CNPJ inválido',
  'Digitable line must have 47 digits (or 44 for the barcode)':
    'A linha digitável deve ter 47 dígitos (ou 44 para o código de barras)',
  'Due date must be today or later': 'O vencimento deve ser hoje ou uma data futura',
  'Amount must be at least R$ 1,00': 'O valor deve ser de no mínimo R$ 1,00',
  'Numbers only': 'Somente números',
  'Lab. code {{code}}': 'Cód. lab. {{code}}',

  // Financial - Receipts
  Receipts: 'Faturas',
  receipt: 'fatura',
  'View receipts by laboratory': 'Visualize as faturas por laboratório',
  'Select a laboratory, month and year, then click Filter':
    'Selecione o laboratório, o mês e o ano e clique em Filtrar',
  'Download Excel': 'Baixar Excel',
  'Read Receipt': 'Ler Fatura',
  'Allows reading receipts (faturas)': 'Permite ler faturas',
  'Allows reading receipt': 'Permite ler Fatura',
  'Laboratory code': 'Código do laboratório',
  'No laboratories found': 'Nenhum laboratório encontrado',
};

export default ptJSON;
